"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dashboard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CardBox = require("b2b-components/theme/components/CardBox");
var _device = require("b2b-components/utils/device");
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _Group = require("./Group");
require("./Dashboard.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Dashboard = function Dashboard(_ref) {
  var title = _ref.title,
    groups = _ref.groups,
    onLinkClick = _ref.onLinkClick,
    _ref$border = _ref.border,
    border = _ref$border === void 0 ? false : _ref$border,
    deviceType = _ref.deviceType,
    className = _ref.className;
  var rootClassName = (0, _classnames["default"])('cds-Dashboard', {
    'cds-Dashboard--Mobile': (0, _device.isMobile)(deviceType),
    'cds-Dashboard--Bordered': border
  }, className);
  var renderContent = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, title && /*#__PURE__*/_react["default"].createElement("h3", {
      className: "cds-Dashboard-Title"
    }, title), Array.isArray(groups) && groups.map(function (group, index) {
      return /*#__PURE__*/_react["default"].createElement(_Group.Group, {
        title: group.title,
        items: group.items,
        onLinkClick: onLinkClick,
        key: (0, _key.createKey)(index, 'group')
      });
    }));
  }, [title, groups, onLinkClick]);
  if (border) {
    return /*#__PURE__*/_react["default"].createElement(_CardBox.CardBox, {
      className: rootClassName,
      titleSize: _CardBox.CARD_BOX_TITLE_SIZE["default"]
    }, renderContent());
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, renderContent());
};
exports.Dashboard = Dashboard;